<template>
    <div class="w-full">
        <component
            :is="dialog.comp1"
            v-bind="{ ...dialog.props1 }"
            v-model="picker"
            @click:outside="validate(true)"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    ref="textField"
                    v-bind="attrs"
                    v-on="on"
                    v-model="input"
                    outlined
                    dense
                    :disabled="disabled"
                    :label="label"
                    :error-messages="error"
                    :rules="rules"
                    :clearable="clearable"
                    :hide-details="hideDetails"
                    :validate-on-blur="!!input"
                    maxlength="10"
                    prepend-inner-icon="cake"
                    placeholder="mm/dd/yyyy"
                    @click:clear="$emit('clear')"
                    @input="[maskDate, (picker = false)]"
                ></v-text-field>
            </template>
            <v-date-picker
                no-title
                next-icon="chevron_right"
                prev-icon="chevron_left"
                class="soli-round"
                v-model="selected"
                :active-picker.sync="activePicker"
                :min="min"
                :max="max ?? globalMomentISO(new Date())"
                :full-width="$vuetify.breakpoint.smAndDown"
                @input="picker = false"
                @change="saveBirthday"
            ></v-date-picker>
        </component>
    </div>
</template>

<script>
import { VMenu, VBottomSheet } from "vuetify/lib";
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    components: {
        VMenu,
        VBottomSheet,
    },
    data: function () {
        return {
            picker: null,
            activePicker: null,
            rules: [],
        };
    },
    props: {
        label: {
            type: String,
            default: "Birthday",
        },
        value: {
            type: String,
            default: "",
        },
        error: {
            type: String,
            default: "",
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [String, Boolean],
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        min: {
            type: String,
            default: "1900-01-01",
        },
        max: {
            type: String,
            default: null,
        },
    },
    computed: {
        dialog() {
            return {
                comp1: this.$vuetify.breakpoint.smAndDown
                    ? "v-bottom-sheet"
                    : "v-menu",
                props1: {
                    "close-on-content-click": false,
                    "nudge-right": "40",
                    "max-width": "450px",
                    "offset-y": true,
                    "min-width": "290px",
                    ref: "menu",
                },
            };
        },
        selected: {
            get() {
                if (!this.value || !moment(new Date(this.value)).isValid()) {
                    return null;
                }
                return new Date(this.value).toISOString().substr(0, 10);
            },
            set(value) {
                this.$emit("input", this.globalMomentUTCDate(value));
            },
        },
        input: {
            get() {
                return this.maskDate(this.value);
            },
            set(value) {
                if (value?.length == 10) this.$refs.textField.validate();
                this.$emit("input", value);
            },
        },
    },
    methods: {
        limitDigits(event) {
            if (event.metaKey || event.ctrlKey || event.key.length > 1) return;
            if (event.key < "0" || event.key > "9") {
                event.preventDefault();
            }
        },
        handlePaste(event) {
            event.preventDefault();
            const paste = (event.clipboardData || window.clipboardData).getData(
                "text"
            );
            const formatted = this.maskDate(paste);
            const input = this.$refs.textField.$refs.input;
            if (input) input.value = formatted || "";
            this.$emit("input", formatted);
        },
        maskDate(value) {
            if (!value) return;
            let x = value
                .replace(/\D/g, "")
                .match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
            return !x[2] ? x[1] : x[1] + "/" + x[2] + (x[3] ? "/" + x[3] : "");
        },
        saveBirthday(birthday) {
            this.$refs.menu.save(birthday);
        },
        validate(val) {
            if ((!this.required || this.picker) && !this.value) {
                this.rules = [];
            } else {
                this.rules = val
                    ? [
                          (val) =>
                              ((val || "").length == 10 &&
                                  moment(new Date(val)).isValid() &&
                                  moment(new Date(val)) < moment() &&
                                  moment(new Date(val)) >
                                      moment("1900-01-01")) ||
                              "Please enter a valid birthday",
                      ]
                    : [];
            }
            this.$nextTick(() => this.$refs.textField.validate());
        },
    },
    mounted() {
        this.$emit("mounted");
        this.validate(true);
        const input = this.$refs.textField.$refs.input;
        if (input) {
            input.addEventListener("keypress", this.limitDigits);
            input.addEventListener("paste", this.handlePaste);
        }
    },
    beforeDestroy() {
        const input = this.$refs.textField?.$refs.input;
        if (input) {
            input.removeEventListener("keypress", this.limitDigits);
            input.removeEventListener("paste", this.handlePaste);
        }
    },
    watch: {
        picker(val) {
            val && setTimeout(() => (this.activePicker = "YEAR"));
            this.validate(!val);
        },
    },
};
</script>
